import Polyglot from 'node-polyglot';
import type { InterpolationOptions } from 'node-polyglot';

const polyglot = window.polyglot || new Polyglot({ allowMissing: true });

type Options = InterpolationOptions & {
  grammarCount?: number;
}

const t = (phrase: string, options?: Options): string => {
  if (options?.grammarCount === 0 && polyglot.has(`${phrase}.zero`)) {
    phrase += '.zero';
  } else if (options?.grammarCount === 1 && polyglot.has(`${phrase}.one`)) {
    phrase += '.one';
  } else if (options?.grammarCount !== undefined) {
    phrase += '.other';
  }
  return polyglot.t(phrase, options);
};

export default t;
